"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUTATION = void 0;
var graphql_tag_1 = require("graphql-tag");
var invitation_1 = require("../fragments/invitation");
exports.MUTATION = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AcceptInvite($token: String!) {\n    acceptInvite(token: $token) {\n      invitation {\n        ...InvitationFields\n      }\n      result\n    }\n  }\n  ", "\n"], ["\n  mutation AcceptInvite($token: String!) {\n    acceptInvite(token: $token) {\n      invitation {\n        ...InvitationFields\n      }\n      result\n    }\n  }\n  ", "\n"])), invitation_1.GqlInvitationFragment);
var templateObject_1;
//# sourceMappingURL=accept-invite.js.map